export const iconFontAwesomeEducationSchoolFlag = (
	<i className="fa-solid fa-school-flag"></i>
);
